module.exports = __webpack_public_path__ + "static/mastodon-e62feba5e0a72c2e1151a292aa2f357c.png";